<template>
         <b-tabs class="nav-tabs-top nav-responsive-lg" card>
          <b-tab class="e-mtavr-17">
              <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body">
            <div class="media-body e-mtavr-15">
              ზოგადი ინფორმაცია
            </div>
          </a>
             </template>
             <b-card-text>
            <div class="card-body w-100">
                <div class="row e-eng-font2">
                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        <div class="d-flex align-items-center justify-content-sm-between g-mb-5">
                            <h2 class="g-font-weight-300 g-mr-10">{{businessDetails.businessName}}</h2>
                        </div>
                        <h4 class="h6 g-font-weight-300 g-mb-10" v-if="businessDetails.aliases.length > 0">
                            <i class="fas fa-clipboard-list g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                            <span class="e-nusx-8"><small>სხვა ცნობილი სახელები:</small></span>
                            <ul class="mb-0 mt-1">
                                <li v-for="a in businessDetails.aliases" :key="a.$index">{{a.businessName}}</li>
                            </ul>
                        </h4>
                        <h4 class="h6 g-font-weight-300 g-mb-10">
                            <i class="fas fa-info-circle g-pos-rel g-top-1 g-mr-5 g-color-gray-dark-v5"></i>
                            <span class="e-nusx-8"><small>დამთხვევის პროცენტი:</small></span><strong> {{businessDetails.score}}%</strong> &nbsp;
                        </h4>
                        <h4 class="h6 g-font-weight-300 g-mb-10" v-if="businessDetails.telephoneNumber">
                            <i class="fas fa-phone-square-alt g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                            <span class="e-nusx-8"><small>ტელეფონის ნომერი:</small></span><strong> {{businessDetails.telephoneNumber}}</strong> &nbsp;
                        </h4>
                        <h4 class="h6 g-font-weight-300 g-mb-10" v-if="businessDetails.faxNumber">
                            <i class="fas fa-phone-square g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                            <span class="e-nusx-8"><small>ფაქსი:</small></span><strong> {{businessDetails.faxNumber}}</strong> &nbsp;
                        </h4>
                        <h4 class="h6 g-font-weight-300 g-mb-10" v-if="businessDetails.website">
                            <i class="fas fa-globe g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                            <span class="e-nusx-8"><small>ვებ გვერდი:</small></span><strong> {{businessDetails.website}}</strong> &nbsp;
                        </h4>
                    </div>
                    <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12">
                        <div
                                class="col-xl-6 col-sm-12 col-md-6 col-lg-6"
                                v-for="(ad, index) in businessDetails.addresses"
                                :key="ad.$index"
                              >
                                <div class="card mb-3 e-no-box-shadow">
                                  <div class="card-header e-nusx-8">
                                    <strong>
                                      მისამართი #
                                      <span class="e-eng-font">{{index+1}}</span>
                                    </strong>
                                  </div>
                                  <div class="card-body">
                                    <p class="card-text" v-if="ad.address1 || ad.address2 || ad.address3 ||ad.address4">
                                      <span class="e-nusx-8">
                                        <small>მისამართი:</small>
                                      </span>
                                      <strong>
                                        {{ad.address1?ad.address1 + ',': ''}}
                                        {{ad.address2?ad.address2 + ',': ''}}
                                        {{ad.address3?ad.address3 + ',': ''}}
                                        {{ad.address4?ad.address4: ''}}
                                      </strong>
                                    </p>
                                    <p class="card-text" v-if="ad.city">
                                      <span class="e-nusx-8">
                                        <small>ქალაქი:</small>
                                      </span>
                                      <strong>{{ad.city?ad.city: ''}}</strong>
                                    </p>
                                    <p class="card-text" v-if="ad.country.name">
                                      <span class="e-nusx-8">
                                        <small>ქვეყანა:</small>
                                      </span>
                                      <strong>{{ad.country.name?ad.country.name: ''}}</strong>
                                    </p>
                                    <p class="card-text" v-if="ad.county">
                                      <span class="e-nusx-8">
                                        <small>რეგიონი:</small>
                                      </span>
                                      <strong>{{ad.county?ad.county: ''}}</strong>
                                    </p>
                                    <p class="card-text" v-if="ad.postcode">
                                      <span class="e-nusx-8">
                                        <small>საფოსტო ინდექსი:</small>
                                      </span>
                                      <strong>{{ad.postcode?ad.postcode: ''}}</strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                    </div>
                </div>
            </div>
            </b-card-text>
          </b-tab>
          <b-tab v-if="businessDetails.linkedPersons.length > 0">
              <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body">
            <div class="media-body e-mtavr-15">
              დაკავშირებული პირები
              <!-- <div class="small e-nusx-8">სანქცირებულ ფიზიკურ პირთა სიაში მომხდარი განახლებები</div> -->
            </div>
          </a>
             </template>
            <div class="card-body">
              <div class="table-responsive">
                          <table class="table u-table--v1 mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th class="e-mtavr-17">მონაცემთა ბაზაში ჩანაწერის ნომერი</th>
                                <th class="e-mtavr-17">სრული სახელი</th>
                                <th class="e-mtavr-17">კავშირის განმარტება</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(lp, index) in businessDetails.linkedPersons"
                                :key="lp.$index"
                              >
                                <th scope="row">{{index+1}}</th>
                                <td class="text-center">{{lp.personId}}</td>
                                <td>{{lp.name}}</td>
                                <td>{{lp.association}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
            </div>
          </b-tab>
          <b-tab v-if="businessDetails.linkedBusinesses.length > 0">
              <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body">
            <div class="media-body e-mtavr-15">
              დაკავშირებული ბიზნესები
              <!-- <div class="small e-nusx-8">სანქცირებულ ფიზიკურ პირთა სიაში მომხდარი განახლებები</div> -->
            </div>
          </a>
             </template>
            <div class="card-body w-100">
                <table class="table u-table--v1 mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th class="e-mtavr-17">ბიზნესის ნომერი</th>
                                <th class="e-mtavr-17">ბიზნესის სახელი</th>
                                <th class="e-mtavr-17">კავშირის განმარტება</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(lb, index) in businessDetails.linkedBusinesses"
                                :key="lb.$index"
                              >
                                <th scope="row">{{index+1}}</th>
                                <td>{{lb.businessId}}</td>
                                <td>{{lb.businessName}}</td>
                                <td>{{lb.linkDescription}}</td>
                              </tr>
                            </tbody>
                          </table>
            </div>
          </b-tab>
          <b-tab v-if="businessDetails.articles.length > 0">
              <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body">
            <div class="media-body e-mtavr-15">
              სტატიები და დოკუმენტები
              <!-- <div class="small e-nusx-8">სანქცირებულ ფიზიკურ პირთა სიაში მომხდარი განახლებები</div> -->
            </div>
          </a>
             </template>
            <div class="card-body">
                <div class="table-responsive">
                          <table class="table u-table--v1 mb-0" style="max-weight: 100%!important">
                            <thead>
                              <tr>
                                <th class="e-mtavr-17">დოკუმენტის თარიღი და კატეგორია</th>
                                <th class="e-mtavr-17">დოკუმენტი</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="a in businessDetails.articles"
                                :key="a.$index"
                              >
                                <td>{{a.dateCollected}}<br><span v-for="cat in a.categories" :key="cat.$index">{{cat.name}}; </span></td>
                                <td>
                                  <p><span class="e-nusx-8">სათაური: </span><strong>{{a.snippet?a.snippet.title:""}}</strong></p>
                                  <p><span class="e-nusx-8">მოკლე შინაასი / ციტატა: </span><strong>{{a.snippet?a.snippet.summary:""}}</strong></p>
                                  <p v-if="a.snippet"><span class="e-nusx-8">საინტერესო ფრაზები: </span><strong  v-for="kw in a.snippet.keywordsMatched" :key="kw.$index">{{kw}}</strong></p>
                                  <p v-if="a.snippet"><span class="e-nusx-8">წყარო: </span><a :href="a.originalURL">{{a.originalURL}}</a></p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
            </div>
          </b-tab>
          <b-tab v-if="businessDetails.notes.length > 0">
              <template #title>
            <a href="javascript:void(0)" class="media align-items-center bg-transparent text-body">
            <div class="media-body e-mtavr-15">
              დამატებითი ინფორმაცია
              <!-- <div class="small e-nusx-8">სანქცირებულ ფიზიკურ პირთა სიაში მომხდარი განახლებები</div> -->
            </div>
          </a>
             </template>
              <div class="card-body">
                  <div v-for="n in businessDetails.notes" :key="n.$index">
                          <p class="card-text">
                            <span class="icon-arrow-right-circle"></span>
                            <span class="e-nusx-8" v-if="n.dataSource">
                              <small>ინფორმაციის წყარო:</small>
                            </span>
                            {{n.dataSource? n.dataSource.name + ";": ""}}
                            <span class="e-nusx-8">
                              <small>ინფორმაცია:</small>
                            </span>
                            {{n.text}}
                          </p>
                        </div>
              </div>
          </b-tab>
        </b-tabs>
</template>

<script>
export default {
  props: ['businessDetails', 'investigatingRequest'],
  Data () {
    return {

    }
  },
  mounted () {
  }
}
</script>

<style>

</style>
